import { render, staticRenderFns } from "./ApplicationDocumentsTab.vue?vue&type=template&id=679d1b02&"
import script from "./ApplicationDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./ApplicationDocumentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports